<template>
  <BaseTemplate :currentUser="currentUser" :isTop="true">
    <div v-if="packList" class="top">
      <!-- <TopIconArea></TopIconArea> -->
      <PackMenuList v-if="isPackListLoaded" :cardTypeList="filteredCardTypeList"></PackMenuList>

      <div class="_pack_list" v-if="-1 == showCardType && showCardType != 11">
        <span v-if="!inputBoard">
          <div class="post_button_area">
            <BlackGradationButton
              class="square-button"
              text="entry post"
              @handleSquareBtnClick="showInputArea"
            />
          </div>
          <span v-if="postItemList.length > 0">
            <div
              class="post_list"
              v-for="(postItem, i) in postItemList"
              :key="i"
            >
              <div class="_title">
                <span>
                  {{ postItem.name }}
                </span>
                <span>
                  {{ postItem.created }}
                </span>
              </div>
              <div class="content">{{ postItem.content }}</div>
              <div class="images">
                <div
                  class="image"
                  v-for="(image, j) in postItem.images"
                  :key="j"
                >
                  <img :src="image" alt="" @click="clickImage(image)" />
                </div>
              </div>
            </div>
            <BoxPager
              v-if="page && page.pages.length > 0"
              class="box-pager"
              :totalPageCount="page.all_page"
              :currentPageCount="page.page"
              :dispBoxCount="page.pages.length"
              :pages="page.pages"
              @handlePagerClick="changeCurrentPageCount"
              @handleSquareBtnClick="changeCurrentPageCount"
            />
          </span>
          <div v-else class="no_item_list">message empty</div>
        </span>
        <PostNewArea
          v-else
          @handleBtnClick="savePost"
          @handleBackBtnClick="closeSavePost"
        ></PostNewArea>
      </div>

      <!-- <div class="_pack_list" v-if="-1 == showCardType">
        <div class="twitter_block">
          <iframe src="/twitter.html"></iframe>
        </div>
      </div> -->
      <span v-for="(cardType, i) in cardTypeList" :key="i">
        <div class="_pack_list" v-if="cardType.id == showCardType">
          <div class="product-list">
            <ProductBanner
              v-for="packItem in productList[cardType.id]"
              :key="packItem.id"
              class="banner"
              :data-pack-id="packItem.id"
              :packItem="packItem"
              :currentUser="currentUser"
              :top="true"
              @handleCardHide="CardHideChange"
              @handlePassword="PasswordInputChange"
              @handleLoginClick="goToLogin"
              @handleBuyClick="goToConfirmBuyProduct"
            />
          </div>
        </div>
      </span>
      <div class="_pack_list">
        <div class="product-list" v-if="999995 == showCardType">
          <ProductBanner
            v-for="packItem in productList[999995]"
            :key="packItem.id"
            class="banner"
            :data-pack-id="packItem.id"
            :packItem="packItem"
            :currentUser="currentUser"
            :top="true"
            @handleCardHide="CardHideChange"
            @handlePassword="PasswordInputChange"
            @handleLoginClick="goToLogin"
            @handleBuyClick="goToConfirmBuyProduct"
          />
        </div>
        <div class="product-list" v-if="999996 == showCardType">
          <ProductBanner
            v-for="packItem in productList[999996]"
            :key="packItem.id"
            class="banner"
            :data-pack-id="packItem.id"
            :packItem="packItem"
            :currentUser="currentUser"
            :top="true"
            @handleCardHide="CardHideChange"
            @handlePassword="PasswordInputChange"
            @handleLoginClick="goToLogin"
            @handleBuyClick="goToConfirmBuyProduct"
          />
        </div>
      </div>
    </div>
    <CommonOverlay class="overlay" v-show="isImageModal">
      <CommonModal class="modal">
        <div>
          <img class="overlay_image" :src="imageUrl" alt="" />
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="isImageModal = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay
      class="overlay"
      v-show="hideCard"
      @handleOverlayClick="hideCard = false"
    >
      <CommonModal class="modal">
        <div>
          {{ t('本商品の内容は全て非公開となります。') }}
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="hideCard = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="isPassword" @handleOverlayClick="isPassword = false">
      <CommonModal class="modal">
        <div>
          {{t('パスワード入力')}}
        </div>
        <TextBox class="text-box" v-model="password"/>
        <ErrorMessage
          v-if="errorMessagePackPass"
          class="error-message"
          :message="errorMessagePackPass"
        />
        <div class="modal-button-area">
          <BuyButton
            :isArrow="false"
            class="send-button"
            :text="t('送信')"
            @handleSquareBtnClick="savePassword"
          />
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="isPassword = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay register-country" v-show="isCountryPopup">
      <CommonModal class="modal">
        <div class="register-country-title">
          In order to prevent unauthorized access, we ask for your cooperation
          in selecting the country name.
        </div>
        <SelectBox
          class="register-country-select"
          :options="countryList"
          :selectedOption="countryId"
          @handleSelectChange="changeCountry"
        />
        <ErrorMessage
          v-if="errorMessageCountryId"
          class="error-message"
          :message="errorMessageCountryId"
        />
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="save"
            :isSub="true"
            @handleSquareBtnClick="saveCountry"
          />
        </div>
      </CommonModal>
    </CommonOverlay>

    <CommonOverlay class="overlay_conf" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <GrayCloseButton
          class="close_button"
          @handleClick="closeModal"
        ></GrayCloseButton>
        <div class="block">
          <div>{{ buyCoin | comma }}{{ t('コインを')}}</div>
          <div>{{ t('消費して') }}<br>{{ count | comma }}{{ t('回ガチャを引く') }}</div>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            @handleSquareBtnClick="buyPack"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import { separateCharacterNumber } from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
// import TopIconArea from '@/components/molecules/TopIconArea.vue';
// import ShadowButton from '@/components/molecules/ShadowButton.vue';
// import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import PostNewArea from '@/components/molecules/PostNewArea.vue';
// import RoundButton from '@/components/atoms/RoundButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import GrayCloseButton from '@/components/atoms/GrayCloseButton.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import PackMenuList from '@/components/pages/Top/PackMenuList.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';

export default {
  name: 'Top',

  components: {
    BaseTemplate,
    ProductBanner,
    // TopIconArea,
    // ShadowButton,
    BlackGradationButton,
    PostNewArea,
    BoxPager,
    // RoundButton,
    CommonOverlay,
    CommonModal,
    GrayCloseButton,
    SquareButton,
    SelectBox,
    ErrorMessage,
    PackMenuList,
    BuyButton,
    TextBox,
    SimpleButton,
  },

  data: () => ({
    productList: [],
    inputBoard: false,
    // showCardType: 1,
    isImageModal: false,
    imageUrl: '',
    isCountryPopup: false,
    countryId: '',
    errorMessageCountryId: null,
    errorMessageCount: null,
    errorMessagePackPass: null,
    isOpenConfirm: false,
    currentPack: null,
    count: 1,
    hideCard: false,
    isPassword: false,
    password: '',
    packId: null,
    targetPackId: null,
    shouldScrollToPack: false,
    cardTypeRestored: false,
    isPackListLoaded: false,
  }),
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      packList: 'pack/packList',
      cardTypeList: 'cardType/cardTypeList',
      showCardType: 'pack/topCardType',
      postList: 'post/postList',
      page: 'post/page',
      countryCheckResult: 'country/countryCheckResult',
      countryList: 'country/countryList',
      changeUserInformationResult: 'user/changeUserInformationResult',
      packCheckResult: 'pack/packCheckResult',
      buyPackResult: 'pack/buyPackResult',
      currentLanguage: 'user/currentLanguage',
      savePackPassword: 'pack/savePackPassword',
    }),
    postItemList() {
      if (this.postList.list) {
        const formattedItemList = this.postList.list.map(
          (item) => ({
            ...item,
            name:
              process.env.VUE_APP_LANG_MODE === 'en'
                ? `${item.lastName} ${item.middleName} ${item.firstName}`
                : `${item.lastName} ${item.firstName}`,
          }),
          [],
        );
        return formattedItemList;
      }
      return [];
    },
    buyCoin() {
      if (this.currentPack) {
        return this.currentPack.point * this.count;
      }
      return 0;
    },
    // パックがあるカードタイプのIDリスト
    cardTypesWithPacks() {
      const typeIds = {};
      Object.keys(this.productList).forEach((key) => {
        if (this.productList[key] && this.productList[key].length > 0) {
          typeIds[key] = true;
        }
      });
      return typeIds;
    },
    // パックがあるタイトルのみにフィルタリング
    filteredCardTypeList() {
      if (!this.cardTypeList || this.cardTypeList.length === 0) {
        return [];
      }
      const filtered = [];
      // ボーナス（999995）はcardTypeListに含まれないため、先頭に追加
      if (this.cardTypesWithPacks[999995]) {
        filtered.push({ id: 999995, name: 'ボーナス' });
      }
      // MIX（999996）はcardTypeListに含まれないため、ボーナスの次に追加
      if (this.cardTypesWithPacks[999996]) {
        filtered.push({ id: 999996, name: 'MIX' });
      }
      // 通常のカードタイプをフィルタリングして追加
      this.cardTypeList.forEach((cardType) => {
        if (this.cardTypesWithPacks[cardType.id]) {
          filtered.push(cardType);
        }
      });
      return filtered;
    },
  },
  watch: {
    packList(newList) {
      // 前回のデータをクリア
      this.productList = [];
      this.isPackListLoaded = false;
      for (let i = 0; i < newList.list.length; i += 1) {
        const isBonus = newList.list[i].is_bonus === 1 || newList.list[i].is_bonus === '1';
        if (isBonus) {
          // ボーナスパックはボーナスタブのみに表示
          if (!this.productList[999995]) {
            this.productList[999995] = [];
          }
          this.productList[999995].push(newList.list[i]);
        } else {
          // 通常パックは元のカードタイプに表示
          const idx = newList.list[i].card_type;
          if (!this.productList[idx]) {
            this.productList[idx] = [];
          }
          this.productList[idx].push(newList.list[i]);
        }
      }
      // パックリスト読み込み完了
      this.isPackListLoaded = true;
      // 次のティックでcomputedプロパティの更新を待ってから初期選択
      this.$nextTick(() => {
        // sessionStorageから復元済みの場合は上書きしない
        if (this.cardTypeRestored) {
          return;
        }
        // 初期表示はボーナス以外の最初のタイトルを選択
        const firstNonBonus = this.filteredCardTypeList.find(
          (cardType) => cardType.id !== 999995,
        );
        if (firstNonBonus) {
          this.$store.dispatch('pack/setTopCardType', firstNonBonus.id);
        }
      });
      // パックリストが読み込まれた後、指定されたパックIDにスクロール
      if (this.shouldScrollToPack && this.targetPackId) {
        this.$nextTick(() => {
          this.scrollToPackId(this.targetPackId);
          this.shouldScrollToPack = false;
          this.targetPackId = null;
        });
      }
    },
    // countryCheckResult() {
    //   if (this.countryCheckResult) {
    //     if (this.countryCheckResult.is_login && !this.countryCheckResult.is_country) {
    //       this.$router.push({ path: '/user-address' });
    //     }
    //   }
    // },
    savePackPassword(newVal) {
      if (newVal?.status === 'error') {
        this.errorMessagePackPass = newVal.message;
      } else {
        this.errorMessagePackPass = null;
        this.isPassword = false;
        this.password = '';
        // card_hide_flagチェック: 非公開の場合はページにとどまる
        let pack = null;
        for (const key of Object.keys(this.productList)) {
          const list = this.productList[key];
          if (Array.isArray(list)) {
            pack = list.find(p => String(p.id) === String(this.packId));
            if (pack) break;
          }
        }
        if (pack && pack.card_hide_flag === 1) {
          // パス保存後に再取得
          this.productList = [];
          this.$store.dispatch('pack/setPackList', '');
        } else {
          // 戻る操作時にタブとスクロール位置を復元するため、sessionStorageに保存
          const cardType = this.$store.getters['pack/topCardType'];
          if (cardType) {
            sessionStorage.setItem('lastCardType', String(cardType));
            sessionStorage.setItem('lastPackId', String(this.packId));
          }
          // パスワード解除後に詳細ページへ遷移
          this.$router.push({ path: '/pack-detail', query: { packId: this.packId } });
        }
      }
    },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isCountryPopup = false;
        } else {
          const { country_id: countryId } = newVal.errors;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
        }
      }
    },
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          // const query = {
          //   packId: this.$route.query.packId,
          //   buyCount: this.count,
          // };
          this.$store.dispatch('pack/clearPackCheckResult');
          // this.$router.push({ path: '/confirm-buy-product', query });
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          alert(this.errorMessageCount);
        }
      }
    },
  },

  created() {
    this.$store.dispatch('pack/setPackList', '');
    this.$store.dispatch('cardType/setCardTypeList');
    // this.$store.dispatch('post/getPostList', { pageNumber: 1 });
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('country/setCountryCheckResult');
    const { apple, login_error: loginError } = this.$route.query;
    if (apple || loginError) {
      this.$store.dispatch('user/setShowLoginPage', true);
    }
    // sessionStorageからカードタイプとパックIDを復元（パック詳細から戻った場合）
    const savedCardType = sessionStorage.getItem('lastCardType');
    const savedPackId = sessionStorage.getItem('lastPackId');
    if (savedCardType) {
      sessionStorage.removeItem('lastCardType');
      sessionStorage.removeItem('lastPackId');
      this.cardTypeRestored = true;
      this.$store.dispatch('pack/setTopCardType', Number(savedCardType));
      if (savedPackId) {
        this.targetPackId = savedPackId;
        this.shouldScrollToPack = true;
      }
    } else {
      // デフォルトで999996（MIX）を選択
      this.$store.dispatch('pack/setTopCardType', 999996);
    }
  },

  methods: {
    goToProductDetail(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
    },
    goToLogin() {
      // this.$router.push({ path: '/' });
      this.$store.dispatch('user/setShowLoginPage', true);
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToTermsOfService() {
      this.$router.push('/terms-of-service');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    moveList(index) {
      this.$router.push({ path: '/pack-list', query: { index } });
    },
    showTokkyo() {
      window.open('https://xeroplace.jp/25/');
    },
    goMyPage() {
      if (this.currentUser.is_login === '1') {
        this.$store.dispatch('user/setShowMyPage', true);
      } else {
        this.$store.dispatch('user/setShowLoginPage', true);
      }
    },
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
      // this.showCardType = type;
    },
    changeCurrentPageCount(pageNumber) {
      // this.$store.dispatch('post/getPostList', { pageNumber });
      console.log(pageNumber);
    },
    savePost({ content, images }) {
      const postParams = {
        content,
        images,
      };
      this.$store.dispatch('post/savePost', { postParams });
    },
    closeSavePost() {
      this.inputBoard = false;
    },
    CardHideChange() {
      this.hideCard = true;
    },
    PasswordInputChange(packId) {
      this.packId = packId;
      this.isPassword = true;
    },
    savePassword() {
      const postParams = {
        pack_id: this.packId,
        password: this.password,
      };
      this.$store.dispatch('pack/setSavePackPassword', { postParams });
    },
    showInputArea() {
      this.inputBoard = true;
    },
    clickImage(image) {
      this.isImageModal = true;
      this.imageUrl = image;
    },
    changeCountry(countryId) {
      this.countryId = countryId;
    },
    saveCountry() {
      const postParams = {
        country_id: this.countryId,
      };
      this.$store.dispatch('user/changeUserInformation', { postParams });
    },
    goToConfirmBuyProduct(pack, count) {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/' });
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      const postParams = {
        pack_id: pack.id,
        count: String(count),
      };
      this.currentPack = pack;
      this.count = count;
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    closeModal() {
      this.isOpenConfirm = false;
    },
    buyPack() {
      this.localBuyPack();
    },
    changePassword() {
      this.isPassword = false;
    },
    changePasswordInput() {
      this.isPassword = true;
    },
    changePasswordInput2() {
      this.isPassword = false;
    },
    changePasswordInput3() {
      this.isPassword = true;
    },
    changePasswordInput4() {
      this.isPassword = false;
    },
    changePasswordInput5() {
      this.isPassword = true;
    },
    changePasswordInput6() {
      this.isPassword = false;
    },
    changePasswordInput7() {
      this.isPassword = true;
    },
    changePasswordInput8() {
      this.isPassword = false;
    },
    changePasswordInput9() {
      this.isPassword = true;
    },
    changePasswordInput10() {
      this.isPassword = false;
    },
    localBuyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { result } = buyPackResult;
          const { count } = buyPackResult.errors;
          if (result === -100) {
            this.localBuyPack();
            return;
          }
          window.alert(count);
          this.isOpenConfirm = false;
        }
      })();
    },
    scrollToPackId(packId) {
      // パック要素の位置が安定するまで待ってからスクロール
      let lastTop = -1;
      let stableCount = 0;
      const check = (attempts) => {
        const packElement = document.querySelector(`[data-pack-id="${packId}"]`);
        if (!packElement) {
          if (attempts < 50) {
            setTimeout(() => check(attempts + 1), 200);
          }
          return;
        }
        const currentTop = packElement.getBoundingClientRect().top + window.scrollY;
        if (Math.abs(currentTop - lastTop) < 1) {
          stableCount += 1;
        } else {
          stableCount = 0;
        }
        lastTop = currentTop;
        // 位置が3回連続で安定したらスクロール実行
        if (stableCount >= 3) {
          packElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (attempts < 50) {
          setTimeout(() => check(attempts + 1), 200);
        } else {
          // フォールバック: スクロール実行
          packElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };
      this.$nextTick(() => check(0));
    },
  },
};
</script>

<style lang="scss" scoped>
.color_white {
  color: $white;
}

h2 {
  margin: 0;
  color: $black;
  margin-bottom: 10px;
}

._pack_list {
  margin: 0 auto 50px auto;
  max-width: 1600px;

  .banner_list {
    position: relative;

    ._title {
      color: $white;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }

    .list_button {
      border-radius: 5px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}

.top {
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  margin: 0 auto;

  .product-list {
    display: flex;
    padding: 14px 0;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .banner {
    margin-bottom: 20px;
    width: 49.5%;
    @media screen and (max-width: 680px) {
      width: 100%;
    }
  }

  .double-flex {
    display: flex;
  }

  .shadow-button {
    min-width: 200px;
    max-width: 48%;
    width: 100%;
    height: 40px;
    margin: 20px auto 0;
  }

  .toiawase {
    text-align: center;
    color: $deepGray;
    margin-top: 20px;
  }

  .pc {
    display: block;
  }

  .sp {
    display: none;
  }
}

.message_base {
  margin-bottom: 0;
  margin-top: -80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 28px;
  align-items: center;

  .link {
    color: #285abe;
    cursor: pointer;
    transition: 0.4s;
    font-size: 34px;

    &:hover {
      opacity: 0.4;
    }
  }
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #707070;
  width: 100%;

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 62px;
    }

    .message {
      font-size: 12px;
      margin-left: 15px;
      color: $white;
    }
  }
}

.twitter_block {
  width: 600px;
  margin: auto;

  iframe {
    width: 100%;
    height: 800px;
    border: none;
  }
}

.no_item_list {
  color: $white;
  text-align: center;
  margin-top: 20px;
}

.post_button_area {
  text-align: center;
  margin-bottom: 10px;
}

.post_list {
  background-color: $backColor;
  color: #fff;
  margin-top: 15px;
  padding: 15px;
  border-radius: 10px;
  .content {
    white-space: pre-wrap;
  }
  .images {
    display: flex;
    flex-wrap: wrap;
    .image {
      flex: 0 0 20%;
      max-width: 20%;
      padding: 5px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
        cursor: pointer;
      }
    }
  }
}

.box-pager {
  margin-top: 20px;
}

.modal {
  box-shadow: 10px 10px 10px 5px rgba(0, 0, 0, 0.6);
  width: auto;
  padding: 30px 30px;
  color: $mainColor;
  font-size: 20px;
  .send-button{
    padding: 10px;
    width: 100%;
    font-size: 16px;
  }
  .modal-button-area {
    margin-top: 20px;
  }
}

@media screen and (max-width: 1200px) {
  .top {
    padding-top: 0;

    /* pack_menu_listのスタイルはPackMenuList.vueで管理 */
  }
}

@media screen and (max-width: $tabletWidth) {
  ._pack_list {
    margin: 0;

    .banner_list {
      ._title {
        color: $white;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .top {
    .pc {
      display: none;
    }

    .sp {
      display: block;
    }

    .sub_title {
      padding: 5px 0;
      margin-top: 30px;

      span {
        font-size: 14px;
        margin-right: 4px;
      }

      div {
        font-size: 10px;
        width: 50px;
        padding: 10px 5px;
        border-radius: 100px;
        text-align: center;

        &:hover {
          opacity: 1;
        }
      }
    }

    .banner_base {
      margin: 0 10px 25px 10px;
      width: 100%;
      min-width: 30vw;
      margin-bottom: 25px;
      @media screen and (max-width: 400px) {
        margin: 0 0 20px 0;
      }
    }
  }

  .twitter_block {
    width: auto;
    margin: 0 20px;
    height: auto;
    overflow-y: auto;
  }
}

.overlay {
  overflow: auto;
}

.pack-confirm {
  border-radius: 10px;
  max-width: 600px;
  min-width: 400px;
  padding: 30px;
  position: relative;
  .block {
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 10px 20px;
    font-weight: bold;
    color: $gray2;
    text-align: center;
    div {
      text-align: center;
    }
  }
  .close_button {
    position: absolute;
    right: 7px;
    top: 15px;
  }
  @media screen and (max-width: $mobileWidth) {
    max-width: 90vw;
    min-width: 320px;
    padding: 40px 20px;
    min-height: 400px;
    .block {
      padding: 20px 10px;
    }
  }
}
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  .modal-button-area {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 30px;
    margin-top: 40px;
    .purchase-btn {
      width: 48%;
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      margin: 40px 0;
      align-items: center;
      gap: 25px;
      .purchase-btn {
        width: 100%;
        max-width: 165px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay {
    // justify-content: flex-start!important;
    // align-items: flex-start!important;
    margin-top: 70px;
    padding-bottom: 70px;
    .overlay_image {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.comming_soon {
  color: #fff;
  text-align: center;
  font-size: 36px;
  padding: 40px 0;
}

.register-country {
  .register-country-title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .register-country-select {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay.register-country {
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
